import api from "./apiSmartLogistics";

export default {
  GetExtractionsCategories() {
    return api.get("ExtractionsCategory/GetExtractionsCategories");
  }
};
